import React, { useState } from 'react';
import Modal from 'react-modal';
import emailjs from 'emailjs-com';
import '../styles/Header.css';
import profilePic from '../styles/profile-pic.jpg';

Modal.setAppElement('#root');

function Header() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const submitForm = (event) => {
    event.preventDefault();

    // Send the form data to the specified email
    emailjs.sendForm('service_dfsbl5g', 'template_klcshpw', event.target, 'nxaftpXExnGrKk9Vy')
      .then((result) => {
          alert("Message sent successfully!");
          setModalIsOpen(false); 
      }, (error) => {
          alert("An error occurred, please try again");
      });

    // Send a notification to yourself
    const formData = new FormData(event.target);
    emailjs.send('service_dfsbl5g', 'your_notification_template_id', {
      from_name: formData.get('user_name'),
      from_email: formData.get('user_email'),
      message: formData.get('message'),
    }, 'nxaftpXExnGrKk9Vy')
      .then((result) => {
          console.log("Notification email sent successfully!");
      }, (error) => {
          console.log("Error sending notification email:", error.text);
      });
  };

  return (
    <header className="resume-header">
      <img src={profilePic} alt="Profile" className="profile-pic" />
      <h1>Ranjith Kunduru</h1>
      <p>Software Developer</p>
      <p>I am now looking for a permanent role in software development...</p>
      <p>Email: cnuranjithkunduru@gmail.com</p>
      <p>Location: Hyderabad, India</p>
      <p>Phone: 7036677749</p>
      <button onClick={() => setModalIsOpen(true)} className="hire-me-button">Hire Me</button>
      
      <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)} className="modal-content">
        <form onSubmit={submitForm}>
          <input type="email" name="user_email" placeholder="Your Email" required />
         
          <input type="text" name="user_name" placeholder="Your Name" required />
          <input type="text" name="message" placeholder="enter your message" required />
          <button type="submit">Send</button>
          <button className="close-modal" onClick={() => setModalIsOpen(false)}>&times;</button>
        </form>
      </Modal>
    </header>
  );
}

export default Header;
